module.exports = __webpack_public_path__ + "media/images/flags/32/Niger-b6731beb6c1df4ab1f6351d2e5206f89.png";